export default {
  changeApplicationNo: '变更申请号',
  nameOfChangeApplication: '变更申请名称',
  changeApplicationCriteria: '变更申请标准',
  version: '版本',
  changeContent: '变更申请内容',
  changeApplicant: '变更申请人',
  changeApplicationTime: '变更申请时间',
  status: '状态',
  createAChangeApplication: '新增变更申请',
  viewTheChangeApplication: '查看变更申请',
  editTheChangeApplication: '编辑变更申请',
  pleaseEnterTheChangeRequestNumber: '请输入变更申请号',
  onlyLettersNumbersUnderscores: '只能输入字母/数字/下划线且不能输入纯数字',
  pleaseEnterTheName: '请输入名称',
  pleaseSelectChangeStandard: '请选择变更申请标准',
  ConfirmDeleteTheChangeApplication: '确定要删除该变更申请么?',
}
